import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import CircularProgress from '../styleguide/CircularProgress'
import {
	PageWrapper,
	ProgressContainer,
} from '../styleguide/CommonPageComponents'
import Header from '../components/Header/Header'
import theme from '../styleguide/theme'

const PageWrapperCustom = styled(PageWrapper)`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
`

const Message = styled.div`
	color: ${theme.palette.grey[500]};
	font-size: 0.8rem;
	width: 33%;
	margin: ${theme.spacing(5)} auto 0;
	text-align: center;
	&:first-letter {
		text-transform: uppercase;
	}
`
const LoadingPage: React.FC<{
	message?: string
	logoSrc?: string
	showHeader?: boolean
}> = ({ message, logoSrc, showHeader = true }) => {
	const { t } = useTranslation()

	return (
		<PageWrapperCustom>
			{showHeader === true ? (
				<Header
					hideHomeIcon={true}
					hideProfileMenu={true}
					hideUnavailable={true}
					logoSrc={logoSrc}
				/>
			) : null}
			<ProgressContainer>
				<CircularProgress />
			</ProgressContainer>
			{message && (
				<Message>
					{t('app.loading')} {message}
				</Message>
			)}
		</PageWrapperCustom>
	)
}

export default LoadingPage
